import { render } from "./ImageBlock.vue?vue&type=template&id=7aff0d80"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"

import "./ImageBlock.vue?vue&type=style&index=0&id=7aff0d80&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__